import type { Maybe } from '@adornis/base/utilTypes.js';
import type { RouteOptimizationResult } from '../entities/RouteOptimizationResult.js';
import { extractIDOnlyFromFEKey } from './extractIDOnlyFromFEKey.js';
import { getAreaFromVehicleId } from './getAreaFromVehicleId.js';
import { getTicketRevenue } from './getTicketRevenue.js';
import { getTotalTravelDistanceKm } from './getTotalTravelDistanceKm.js';
import { isInterventionStop } from './isInterventionStop.js';

export function getRouteRevenueByEngineer(selectedPlanning: Maybe<RouteOptimizationResult>) {
  if (!selectedPlanning) return new Map();

  const routeRevenueByEngineer = new Map<
    string,
    { ticketCount: number; ticketRevenue: number; area: string; travelDistanceKm: number }
  >();

  // planned tickets
  for (const route of selectedPlanning?.routes ?? []) {
    const engineerKey = extractIDOnlyFromFEKey(route.vehicleId) ?? extractIDOnlyFromFEKey(route.vehicleName);
    if (!engineerKey) continue;

    const allStops = route.stops ?? [];
    const ticketStops = allStops.filter(stop => stop.type === 'ticket' && !isInterventionStop(stop));
    const ticketRevenue = ticketStops.reduce(
      (sum, stop) => sum + getTicketRevenue(stop.ticketType, stop.serviceDurationMinutes),
      0,
    );
    const ticketCount = ticketStops.length;
    const area = getAreaFromVehicleId(route.vehicleId);
    const travelDistanceKm = getTotalTravelDistanceKm(allStops);
    routeRevenueByEngineer.set(engineerKey, { ticketCount, ticketRevenue, area, travelDistanceKm });
  }
  return routeRevenueByEngineer;
}
